const previewModal = {
    header: '[EN] Podgląd',
    cancel: '[EN] WRÓĆ',
    preview: '[EN] Podgląd'
};

export default previewModal;